import { LINKEDIN_DEMOGRAPHIC_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function ldDemographics(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case LINKEDIN_DEMOGRAPHIC_SUCCESS:

      // const parsedData = JSON.parse(action.payload.data)
      
      return { ...state, data: action.payload.data.elements, errors: null };
      
    default:
      return state;
  }
}